// @flow

import React, { type Node, useEffect } from 'react';
import { useCurrentReceipt, getTransactionFees } from '@tectonics/prs/receipts';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { getMoneyFormat } from '../../../commons/money-format';
import {
  SideDisplayValueItem,
  SideDisplayValueItemTitle,
  SideDisplayValueItemValue,
} from '../side-display-values';
import { useUserInputValue } from '@tectonics/prs/user-input-values';

export function DisplayArgentineEndUserFee(): Node {
  const incomingPayment = useIncomingPayment();
  const receipt = useCurrentReceipt();
  const fee = getTransactionFees(receipt, 'INSTALLMENT_FEE');
  const [,setInstallmentsPlanToken] = useUserInputValue('installmentsPlanToken');

  useEffect(() => {
    if (!fee || !receipt?.installments_plan_token) {
      setInstallmentsPlanToken('');
      return;
    }
    setInstallmentsPlanToken(receipt.installments_plan_token);
  }, [fee, receipt]);

  if (!fee) {
    return null;
  }

  const country = getCountry(incomingPayment);
  const formatAmount = amountToCurrencyString(getMoneyFormat(country));
  const percentValue = getPercentValue(fee);

  return (
    <SideDisplayValueItem data-testid="display_argentine_end_user_fee">
      <SideDisplayValueItemTitle>
        Tasa de Procesamiento {percentValue}
      </SideDisplayValueItemTitle>
      <SideDisplayValueItemValue>
        {formatAmount(fee.amount)}
      </SideDisplayValueItemValue>
    </SideDisplayValueItem>
  );
}

function getPercentValue(fee): string {
  return fee.percent_value ? `(${fee.percent_value}%)` : '';
}
